/** Lightweight conversion tracking — fires dataLayer/gtag events only when GA4 is configured. */
export function track(event, params = {}) {
  try {
    if (typeof window !== "undefined" && Array.isArray(window.dataLayer)) {
      window.dataLayer.push({ event, ...params });
    }
  } catch (_) {}
}
